<template>
  <div>
    <div class="cardContainer">
      <slot name="title" />
      <div class="disclaimer">
        <slot name="description" />
      </div>
      <div v-if="canPostNewComment">
        <b-button
          variant="primary"
          style="margin: 20px 0px 0px"
          @click="openModalComment()"
        >
          {{
            $t(
              "label_evaluation_requirementEvaluation_evaluationComments_newComment_button"
            )
          }}
        </b-button>
      </div>
      <div
        v-if="
          getSelectedRequirement.comments &&
          getSelectedRequirement.comments.length
        "
        style="margin-top: 10px"
      >
        <div
          v-for="(comme, index) of getSelectedRequirement.comments"
          :key="index"
          class="commentContainer"
        >
          <template-evaluation-comment
            :is-organization="isOrganization"
            :comment="comme"
            :index="index"
            :can-edit="canPostNewComment"
            @setEdit="setEdit"
          />
        </div>
      </div>
    </div>
    <evaluation-comments-modal
      :show-modal-comment.sync="showModalComment"
      :comment="comment"
      :requirement="getSelectedRequirement"
      :index="index"
      :is-reply="isReply"
      :parent-comment-index="parentIndex"
    />
  </div>
</template>

<script>
import EvaluationCommentsModal from "../audit/EvaluationCommentsModal.vue";
import { mapGetters } from "vuex";

export default {
  name: "EvaluationNodeComments",
  components: { EvaluationCommentsModal },
  props: ["canPostNewComment", "isOrganization"],
  computed: {
    ...mapGetters(["getSelectedRequirement"]),
  },
  data() {
    return {
      showModalComment: false,
      comment: {},
      index: -1,
      isReply: false,
      parentIndex: -1,
    };
  },
  methods: {
    openModalComment() {
      this.showModalComment = true;
      this.comment = {};
      this.index = -1;
      this.isReply = false;
      this.parentIndex = -1;
    },
    setEdit({ index, isReply, parentIndex }) {
      this.openModalComment();
      if (isReply) {
        if (index !== -1) {
          this.comment = {
            ...this.getSelectedRequirement.comments[parentIndex],
            comment:
              this.getSelectedRequirement.comments[parentIndex].replies[index]
                .comment ||
              this.getSelectedRequirement.comments[parentIndex].replies[index]
                .content,
            ...this.getSelectedRequirement.comments[parentIndex].replies[index],
          };
          delete this.comment.replies;
        }
      } else {
        this.comment = { ...this.getSelectedRequirement.comments[index] };
      }
      this.index = index;
      this.isReply = isReply;
      this.parentIndex = parentIndex;
    },
    closeModal() {
      this.showModalComment = false;
    },
  },
};
</script>

<style lang="sass" scoped>

  .commentContext
    font-weight: bold
    border-bottom: 1px solid #636363

  .commentContainer
    margin: 30px 0px
  .commentText
    padding: 10px 0px
    text-align: justify

.cardContainer
  border-color: #6e6e6e
  padding: 20px
  margin-bottom: 15px
  font-size:    1rem
  h4
    font-size: 1.3rem
    text-transform: uppercase
    margin: 0px
    padding: 0px
    padding-right: 15px
</style>
